const appGlobalScript = appGlobalScriptNs.default || (() => {});
import * as appGlobalScriptNs from '/home/runner/work/smoothly/smoothly/src/global/index.ts';
export const globalScripts = appGlobalScript;
export const globalStyles = "";
